export default "__VITE_ASSET__7tYMHCkl__"